export const ROLES = {
  AUTHENTICATED: 'Authenticated',
  MODERATOR: 'City Moderator',
  ADMIN: 'GMD Administrator'
};
